export default {"src":"/_next/static/media/bottles.a85b53ca.svg","height":372,"width":611,"blurWidth":0,"blurHeight":0};